/**
 * dataLayer event types defined by the Data team. This defines what code will
 * be triggered in GTM when received in the dataLayer.
 */
export const DATALAYER_PUSH_EVENT = {
    updatePageProps: 'Update Page Props',
    track: 'track',
};

/**
 * Key that is captured by GTM and indicates the pushed event is to be sent to
 * Heap
 */
export const SEND_TO_HEAP_KEY = 'sendToHeap';
